"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyAttackDamage = void 0;
const Damage_1 = require("../Damage");
const Duration_1 = require("../Duration");
const core_1 = require("../effects/core");
const enums_1 = require("../enums");
function applyAttackDamage(args) {
    var _a;
    const { attackerId, targetId, toApply, isCrit, attackType } = args;
    if (this.isDeceased(targetId)) {
        return {
            damage: Damage_1.Damage.None,
        };
    }
    let { sequence } = args;
    const defensiveAttr = attackType.includes("magic") ? enums_1.AttributeType.Will
        : enums_1.AttributeType.Toughness;
    const damageId = this.applyEffect(sequence, attackerId, targetId, core_1.DamageEffectArgs.fromAttack(this, toApply.type, attackerId, targetId, enums_1.AttributeType[toApply.primaryAttribute], defensiveAttr, toApply.power, isCrit), Duration_1.Duration.Instant);
    return {
        damage: (_a = this.getEffect(damageId).args.damage) !== null && _a !== void 0 ? _a : Damage_1.Damage.None
    };
}
exports.applyAttackDamage = applyAttackDamage;
